import React, { useState, useEffect } from 'react';

import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';
import Question from 'on_web/components/shared/Question/Question';
import UserProfileContext from 'on_web/context/userProfileContext';
import { getCovid19AntibodiesTestedQuestions } from 'on_web/helpers/questions';

import { useTranslation } from 'react-i18next';

function DiseasesStep2(props) {
  const context = React.useContext(UserProfileContext);
  const [selectedTested, setSelectedTested] = useState(
    context &&
      context.covidPastInfections &&
      context.covidPastInfections.tested_for_covid_19_antibodies != null
      ? context.covidPastInfections.tested_for_covid_19_antibodies === 1
        ? '1'
        : '2'
      : undefined
  );
  const [selectedPositive, setSelectedPositive] = useState(
    context &&
      context.covidPastInfections &&
      context.covidPastInfections.positive_for_covid_19_antibodies != null
      ? context.covidPastInfections.positive_for_covid_19_antibodies === 1
        ? '1'
        : '2'
      : undefined
  );
  const [selectedProvider, setSelectedProvider] = useState(
    context &&
      context.userMetaData &&
      context.userMetaData.covid19AntibodiesTestProvider
      ? context.userMetaData.covid19AntibodiesTestProvider
      : undefined
  );
  const [selectedDate, setSelectedDate] = useState(
    context &&
      context.userMetaData &&
      context.userMetaData.covid19AntibodiesTestDate
      ? context.userMetaData.covid19AntibodiesTestDate
      : undefined
  );
  const [nextDisabled, setNextDisabled] = useState(true);

  const { t } = useTranslation();
  const questions1 = getCovid19AntibodiesTestedQuestions(selectedTested, t);

  const questions2 = [
    {
      checked: selectedPositive === '1',
      value: '1',
      label: t('common.answers.answerYes'),
      id: 'antibodiesPositiveYes',
    },
    {
      checked: selectedPositive === '2',
      value: '2',
      label: t('common.answers.answerNo'),
      id: 'antibodiesPositiveNo',
    },
  ];

  const questions3 = [
    {
      checked: selectedProvider === '1',
      value: '1',
      label: t('onboarding.diseasesSection.diseasesStep2.question1'),
      id: 'provider1',
    },
    {
      checked: selectedProvider === '2',
      value: '2',
      label: t('onboarding.diseasesSection.diseasesStep2.question2'),
      id: 'provider2',
    },
    {
      checked: selectedProvider === '3',
      value: '3',
      label: t('onboarding.diseasesSection.diseasesStep2.question3'),
      id: 'provider3',
    },
    {
      checked: selectedProvider === '4',
      value: '4',
      label: t('onboarding.diseasesSection.diseasesStep2.question4'),
      id: 'provider4',
    },
    {
      checked: selectedProvider === '5',
      value: '5',
      label: t('onboarding.diseasesSection.diseasesStep2.question5'),
      id: 'provider5',
    },
    {
      checked: selectedProvider === '6',
      value: '6',
      label: t('onboarding.diseasesSection.diseasesStep2.question6'),
      id: 'provider6',
    },
  ];

  useEffect(() => {
    setNextDisabled(
      selectedTested == null ||
        (selectedTested === '1' &&
          (selectedPositive == null ||
            selectedProvider == null ||
            selectedDate == null))
    );
  });

  const handleSelectedTested = val => {
    setSelectedPositive(undefined);
    setSelectedProvider(undefined);
    setSelectedDate(null);
    setSelectedTested(val);
  };

  const onClickNext = () => {
    const userMetaData = context ? context.userMetaData : null;
    const covidPastInfections = context ? context.covidPastInfections : null;

    if (props.onClickNext && userMetaData && covidPastInfections) {
      if (selectedTested === '2') {
        covidPastInfections.tested_for_covid_19_antibodies = 0;
        covidPastInfections.positive_for_covid_19_antibodies = 0;
        userMetaData.covid19AntibodiesTestDate = undefined;
        userMetaData.covid19AntibodiesTestProvider = undefined;
      } else {
        covidPastInfections.tested_for_covid_19_antibodies = 1;
        covidPastInfections.positive_for_covid_19_antibodies =
          selectedPositive === '1' ? 1 : selectedPositive === '2' ? 0 : 0;

        userMetaData.covid19AntibodiesTestProvider = selectedProvider;
        userMetaData.covid19AntibodiesTestDate = selectedDate;
      }

      props.onClickNext(userMetaData, covidPastInfections);
    }
  };

  return (
    <React.Fragment>
      <Header />
      {(context == null || context.editMode !== true) && (
        <StepProgressIndicator
          showBasicQuestions={context.showBasicQuestions}
          selectedSlideIx={
            process.env.REACT_APP_HIDE_DNA_SECTION !== 'true' ? 3 : 2
          }
        />
      )}

      <div id="disesasesStep2">
        <Question
          sectionTitle={t(
            'onboarding.diseasesSection.diseasesStep2.sectionTitle1'
          )}
          instructionAbove={t(
            'onboarding.diseasesSection.diseasesStep2.instructionAbove1'
          )}
          radioSelection={{ items: questions1, twoColumns: true }}
          onAnswer={val => handleSelectedTested(val)}
        />

        {selectedTested === '1' && (
          <Question
            instructionAbove={t(
              'onboarding.diseasesSection.diseasesStep2.instructionAbove2'
            )}
            radioSelection={{ items: questions2, twoColumns: true }}
            onAnswer={val => setSelectedPositive(val)}
            showTopBorder={true}
          />
        )}

        {selectedTested === '1' && (
          <Question
            instructionAbove={t(
              'onboarding.diseasesSection.diseasesStep2.instructionAbove3'
            )}
            radioSelection={{ items: questions3, twoColumns: true }}
            onAnswer={val => setSelectedProvider(val)}
            showTopBorder={true}
          />
        )}

        {selectedTested === '1' && (
          <Question
            monthInput={true}
            monthValue={selectedDate}
            minDate={new Date(2020, 1)}
            maxDate={new Date()}
            instructionAbove={t(
              'onboarding.diseasesSection.diseasesStep2.instructionAbove4'
            )}
            onAnswer={val => setSelectedDate(val)}
            showTopBorder={true}
          />
        )}
      </div>

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={props.onClickBack}
        nextButtonDisabled={nextDisabled}
        editMode={context && context.editMode}
      />
    </React.Fragment>
  );
}

export default DiseasesStep2;
